import { FC } from 'react'
import Link from 'next/link'
import Button from 'components/forms/Button'
import Strings from 'project/localisation'
import classNames from 'classnames'

type EnquireNowButtonType = {
  className?: string
}

const EnquireNowButton: FC<EnquireNowButtonType> = ({ className }) => {
  return (
    <div className={classNames('text-center my-10', className)}>
      <Link className={'a-unstyled'} href={'#konnect-form'}>
        <Button theme={'black'} className={'d-block mx-auto'}>
          {Strings.enquireNow}
        </Button>
      </Link>
    </div>
  )
}

export default EnquireNowButton
